import '../../styles/Home.scss';
import { useState } from 'react';
import { Box, Snackbar } from '@mui/material';
import DrawerChatLog from '../../components/chat/share-drives/DrawerChatLog';
import TableListChat from '../../components/chat/share-drives/TableListChat';
import { ChatLogItem, Drive } from '../../models/interfaces';
import React, { useEffect } from 'react';
import { getChatDetail, updateTitle } from '../../services/chat-service';
import { getShareChatList } from '../../services/share-drive-service';
import { STATUS_CODE } from '../../utils/constants';

export default function ShareDrive() {
  const [listChat, setListChat] = useState<Drive[]>([]);
  const [chatLog, setChatLog] = React.useState<ChatLogItem[]>([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [openChatDetail, setOpenChatDetail] = React.useState(false);
  const [openCopyToClibboard, setOpenCopyToClibboard] = React.useState(false);
  // Loading manage
  const [isLoadingChatDetail, setIsLoadingChatDetail] = React.useState(false);
  const [isLoadingListChat, setIsLoadingListChat] = React.useState(false);
  const [selectedId, setSelectedId] = useState<string>();

  const handleMenuRowClick = (id: string) => {
    setSelectedIds([id]);
    setSelectedId(id);
  };

  const handleRowClick = (id: string) => {
    setSelectedIds([id]);
    handleOpenChatDetail(id);
    setSelectedId(id);
  };

  const handleContextMenuClick = () => {};

  const handleCheckBoxChange = (id: string) => {
    let newSelectedIds = [...selectedIds];
    if (selectedIds.includes(id)) {
      newSelectedIds = selectedIds.filter((item) => item !== id);
    } else {
      newSelectedIds.push(id);
    }
    setSelectedIds(newSelectedIds);
  };

  const handleOpenChatDetail = (id: string) => {
    setOpenChatDetail(true);
    handleGetChatDetail(id);
  };

  const handleCloseChatDetail = () => {
    setOpenChatDetail(false);
  };

  const handleGetChatList = async () => {
    try {
      setIsLoadingListChat(true);
      const res = await getShareChatList();
      if (res.status === STATUS_CODE.SUCCESS) {
        setListChat(res.data);
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    } finally {
      setIsLoadingListChat(false);
    }
  };

  const getSelectedItem = (id: string) => {
    return listChat.find((item) => item.id === id);
  };

  const handleGetChatDetail = async (id: string) => {
    try {
      setChatLog([]);
      setIsLoadingChatDetail(true);
      const res = await getChatDetail(id);
      if (res.status === STATUS_CODE.SUCCESS) {
        setChatLog(res.data);
      }
    } catch (error) {
      setChatLog([]);
      // todo handle error
    } finally {
      setIsLoadingChatDetail(false);
    }
  };

  const handUpdateTitleChat = async (id: string, title: string) => {
    try {
      setIsLoadingListChat(true);
      const res = await updateTitle(id, title);
      if (res.status === STATUS_CODE.SUCCESS) {
        handleGetChatList();
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    } finally {
      setIsLoadingListChat(false);
    }
  };

  useEffect(() => {
    handleGetChatList();
  }, []);

  return (
    <div className="home-layout">
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <TableListChat
          dataSource={listChat}
          handleRowClick={handleRowClick}
          handleCheckBoxChange={handleCheckBoxChange}
          selectedIds={selectedIds}
          loading={isLoadingListChat}
          handleMenuClick={handleMenuRowClick}
          handUpdateTitleChat={handUpdateTitleChat}
          handleContextMenuClick={handleContextMenuClick}
        />

        {openChatDetail && (
          <DrawerChatLog
            chatLogs={chatLog}
            handleDrawerClose={handleCloseChatDetail}
            setChatLog={setChatLog}
            chatId={selectedId as string}
            chatDetail={getSelectedItem(selectedId as string)}
            loading={isLoadingChatDetail}
            setOpenCopyToClibboard={setOpenCopyToClibboard}
          />
        )}
      </Box>
      <Snackbar
        message="クリップボードにコピーされました"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={2000}
        onClose={() => setOpenCopyToClibboard(false)}
        open={openCopyToClibboard}
      />
    </div>
  );
}
